import { styled, Box, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/joykit/packages/core/utils';

export const StyledLinkWrapper = styled(Box)``;
const linkWrapperStyles: StyleSystemProps = {
  alignItems: 'center',
  height: '100%',
  paddingX: 6
};

export const StyledLink = styled(Box)``;
const linkStyles: StyleSystemProps = {
  paddingX: 2,
  paddingY: 1,
  position: 'relative',
  color: 'white',
  display: 'inline-flex',
  alignItems: 'center',
  height: '100%',
  transition: animationTransition('color'),

  _after: {
    content: '" "',
    position: 'absolute',
    bottom: 4,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'calc(100% - 10px)'
  },

  _hover: {
    _after: {
      borderBottom: '1px solid',
      borderBottomColor: 'white'
    }
  },
  _active: {
    color: 'mono4'
  },

  _activeLink: {
    _after: {
      borderBottom: '2px solid',
      borderBottomColor: 'white'
    }
  }
};

export const styles = {
  link: linkStyles,
  linkWrapper: linkWrapperStyles
};
